import React from 'react';
import { Link } from 'react-router-dom';
import { BrandMark } from './LandingIcons';
import { FEATURE_PAGES } from './landingContent';

const LandingFooter: React.FC = () => (
  <footer className="lp-footer">
    <div className="lp-wrap">
      <div className="lp-footer-grid">
        <div className="lp-footer-brand">
          <Link to="/" className="lp-brand" aria-label="EzyPrep home">
            <BrandMark />
            <span>EzyPrep</span>
          </Link>
          <p>Film pre-production, from the first page to the last call sheet.</p>
        </div>
        <nav className="lp-footer-col" aria-label="Product">
          <h2>Product</h2>
          <ul>
            <li><Link to="/#features">Features Overview</Link></li>
            {FEATURE_PAGES.map(page => <li key={page.path}><Link to={page.path}>{page.title}</Link></li>)}
          </ul>
        </nav>
        <nav className="lp-footer-col" aria-label="Get started">
          <h2>Get started</h2>
          <ul>
            <li><Link to="/try-free">Create a free account</Link></li>
            <li><Link to="/signin">Sign in</Link></li>
            <li><Link to="/editor/demo/script">Open the demo project</Link></li>
            <li><Link to="/#testimonials">Workflow</Link></li>
            <li><Link to="/#pricing">Pricing</Link></li>
            <li><Link to="/#faq">FAQ</Link></li>
          </ul>
        </nav>
        <div className="lp-footer-col">
          <h2>Contact</h2>
          <ul>
            <li><a href="mailto:sales@ezyprep.com">sales@ezyprep.com</a></li>
          </ul>
        </div>
      </div>
      <div className="lp-footer-bottom">
        <span>&copy; {new Date().getFullYear()} EzyPrep. All rights reserved.</span>
      </div>
    </div>
  </footer>
);

export default LandingFooter;
